"use strict";
// tslint:disable
/**
 * Carrier service API
 * This API provides carrier services for CloudLink platform applications.  All resources except `_spec` and `_status` are secured by an API token passed in the Authorization header.  Collection requests support basic OData syntax.  To manipulate paged data utilize the `$skip` & `$top` query string syntax. For carrier: * Get first 5 results: `/carriers?$top=5` * Skip 5 then get next 5 results: `/carriers?$skip=5&$top=5`  Available phone numbers can be retrieved based on certain criteria with OData `$filter` query parameter: * To retrieve available phone numbers: `/numbers?$filter=country eq 'CA' and type eq 'local' and region eq 'ON' and areaCode eq '613' and substringof('592', number)`  CloudLink supports events from the notifications service.  Notification events have the following information: * topic set to `platform-api-carrier` * subject matching the self link or route of created or edited resource * content matching what was returned to the caller  This provides consumers with a symmetric experience whether using the REST calls or receiving asynchronous notifications.  Some carrier subscription filters are: * Notifications for a specific phone number with id '16135925660':  `^/numbers/16135925660$`
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * CarrierService
 * @class
 */
class CarrierService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-carrier',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Carrier' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Adds carrier data with the given parameters. Must be global admin.
    * @summary Add a carrier
    * @param {CarrierPostRequest} body Carrier POST request object
    * @throws {RequiredError}
    */
    createCarrier(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createCarrier.');
        }
        const path = `/carriers`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a carrier. Must be global admin.
    * @summary Delete a carrier
    * @param {string} carrierName Carrier Name
    * @throws {RequiredError}
    */
    deleteCarrier(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling deleteCarrier.');
        }
        const path = `/carriers/{carrierName}`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve a carrier. Must be at least account admin.
    * @summary Retrieve a carrier
    * @param {string} carrierName Carrier Name
    * @throws {RequiredError}
    */
    getCarrier(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getCarrier.');
        }
        const path = `/carriers/{carrierName}`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return carriers list. Must be at least account admin.
    * @summary Get all carriers list
    * @throws {RequiredError}
    */
    getCarriers(params) {
        const path = `/carriers`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get rate centers that serves the region based on $filter. Must be at least account admin.
    * @summary Get rate centers that serves the region based on $filter
    * @param {string} carrierName Carrier Name
    * @param {string} region States or provinces
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Key for skipping items
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getRateCenters(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getRateCenters.');
        }
        // verify required parameter 'region' is not null or undefined
        if (params.region === null || params.region === undefined) {
            throw new utils_1.RequiredError('region', 'Required parameter region was null or undefined when calling getRateCenters.');
        }
        const path = `/carriers/{carrierName}/regions/{region}/rate-centers`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'region'}}`, String(params.region));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets carrier information associated with the site. Must be account admin.
    * @summary Get carrier information associated with the site.
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @throws {RequiredError}
    */
    getSite(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSite.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getSite.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets carrier information associated with the account. Must be account admin.
    * @summary Get carrier information associated with the account.
    * @param {string} accountId Account Id
    * @throws {RequiredError}
    */
    getSites(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSites.');
        }
        const path = `/accounts/{accountId}/sites`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Change a carrier with the given parameters. Must be global admin.
    * @summary Change a carrier
    * @param {string} carrierName Carrier Name
    * @param {CarrierPutRequest} body Carrier PUT request object
    * @throws {RequiredError}
    */
    updateCarrier(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling updateCarrier.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCarrier.');
        }
        const path = `/carriers/{carrierName}`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a connect order. Must be at least account admin.
    * @summary Create a connect order
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {OrderPostRequest} body Order POST request object
    * @throws {RequiredError}
    */
    createConnectOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createConnectOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createConnectOrder.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConnectOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/connect-orders`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a disconnect order. Must be at least account admin.
    * @summary Create a disconnect order
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {OrderPostRequest} body Order POST request object
    * @throws {RequiredError}
    */
    createDisconnectOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createDisconnectOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createDisconnectOrder.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createDisconnectOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/disconnect-orders`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a port in order. Must be at least account admin.
    * @summary Create a port in order
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {PortInOrderPostRequest} body Port in order POST request object
    * @throws {RequiredError}
    */
    createPortInOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createPortInOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createPortInOrder.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPortInOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/port-in-orders`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Post port in order attachment. Must be at least account admin.
    * @summary Post port in order attachment
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @param {string} body Binary data of the attachment
    * @throws {RequiredError}
    */
    createPortInOrderAttachment(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createPortInOrderAttachment.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createPortInOrderAttachment.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling createPortInOrderAttachment.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPortInOrderAttachment.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/port-in-orders/{orderId}/attachment`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete port in order status. Must be at least account admin.
    * @summary Delete port in order status
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @throws {RequiredError}
    */
    deletePortInOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deletePortInOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deletePortInOrder.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling deletePortInOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/port-in-orders/{orderId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get connect order status. Must be at least account admin.
    * @summary Get connect order status
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @throws {RequiredError}
    */
    getConnectOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getConnectOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getConnectOrder.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getConnectOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/connect-orders/{orderId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get disconnect order status. Must be at least account admin.
    * @summary Get disconnect order status
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @throws {RequiredError}
    */
    getDisconnnectOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getDisconnnectOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getDisconnnectOrder.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getDisconnnectOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/disconnect-orders/{orderId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get port in order status. Must be at least account admin.
    * @summary Get port in order status
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @throws {RequiredError}
    */
    getPortInOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPortInOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPortInOrder.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getPortInOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/port-in-orders/{orderId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a port in order. Must be at least account admin.
    * @summary Update a port in order
    * @param {string} accountId Account Id
    * @param {string} siteId Site Id
    * @param {string} orderId Order Id
    * @param {PortInOrderPutRequest} body Port in order PUT request object
    * @throws {RequiredError}
    */
    updatePortInOrder(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updatePortInOrder.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updatePortInOrder.');
        }
        // verify required parameter 'orderId' is not null or undefined
        if (params.orderId === null || params.orderId === undefined) {
            throw new utils_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling updatePortInOrder.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePortInOrder.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/port-in-orders/{orderId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'orderId'}}`, String(params.orderId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Adds caa phone with the given parameters. Must be global admin.
    * @summary Add a phone number
    * @param {NumberPostRequest} body Number POST request object
    * @throws {RequiredError}
    */
    createNumber(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createNumber.');
        }
        const path = `/numbers`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a tag of a phone number.
    * @summary Create a tag of a phone number
    * @param {string} number Phone number
    * @param {NumberTagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    createTag(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling createTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTag.');
        }
        const path = `/numbers/{number}/tags`
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a phone number. Must be global admin.
    * @summary Delete a phone number
    * @param {string} number Phone number
    * @throws {RequiredError}
    */
    deleteNumber(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling deleteNumber.');
        }
        const path = `/numbers/{number}`
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a tag of a phone number.
    * @summary Delete a tag of a phone number
    * @param {string} number Phone number
    * @param {string} tagId Tag Id
    * @throws {RequiredError}
    */
    deleteTag(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling deleteTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteTag.');
        }
        const path = `/numbers/{number}/tags/{tagId}`
            .replace(`{${'number'}}`, String(params.number))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get available phone numbers from a carrier. Must be at least account admin.
    * @summary Get available phone numbers
    * @param {string} carrierName Carrier Name
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getAvailablePhoneNumbers(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getAvailablePhoneNumbers.');
        }
        const path = `/carriers/{carrierName}/numbers`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get port properties to port to a carrier of an external phone number. Must be at least account admin.
    * @summary Get port properties of an external phone number
    * @param {string} carrierName Carrier Name
    * @param {string} number Phone number
    * @throws {RequiredError}
    */
    getExternalPhoneNumber(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getExternalPhoneNumber.');
        }
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling getExternalPhoneNumber.');
        }
        const path = `/carriers/{carrierName}/external/numbers/{number}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve information of a phone number. Must be a global admin.
    * @summary Get a phone number
    * @param {string} number Phone number
    * @throws {RequiredError}
    */
    getNumber(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling getNumber.');
        }
        const path = `/numbers/{number}`
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return numbers list. Must always include filter for account ID. Must be at least account admin.
    * @summary Get all numbers list
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getNumbers(params) {
        const path = `/numbers`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return all tags associated to the number
    * @summary Get a tag of a phone number
    * @param {string} number Phone number
    * @param {string} tagId Tag Id
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getTag(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling getTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getTag.');
        }
        const path = `/numbers/{number}/tags/{tagId}`
            .replace(`{${'number'}}`, String(params.number))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return all tags associated to the number
    * @summary Get all tags of a phone number
    * @param {string} number Phone number
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getTags(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling getTags.');
        }
        const path = `/numbers/{number}/tags`
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Change a phone numeber with the given parameters. Must be global admin.
    * @summary Change a phone number record
    * @param {string} number Phone number
    * @param {NumberPutRequest} body Phone number PUT request object
    * @throws {RequiredError}
    */
    updateNumber(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling updateNumber.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateNumber.');
        }
        const path = `/numbers/{number}`
            .replace(`{${'number'}}`, String(params.number));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a tag of a phone number.
    * @summary Update a tag of a phone number
    * @param {string} number Phone number
    * @param {string} tagId Tag Id
    * @param {NumberTagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    updateTag(params) {
        // verify required parameter 'number' is not null or undefined
        if (params.number === null || params.number === undefined) {
            throw new utils_1.RequiredError('number', 'Required parameter number was null or undefined when calling updateTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTag.');
        }
        const path = `/numbers/{number}/tags/{tagId}`
            .replace(`{${'number'}}`, String(params.number))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * List billing reports for a range dates. Returns object collection with direct links to the reports, if any.
    * @summary List billing reports.
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    listBillingReports(params) {
        const path = `/billing-reports`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the service API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get service status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a trunk group. Must be at least account admin.
    * @summary Create a trunk group
    * @param {string} carrierName Carrier Name
    * @param {TrunkGroupPostRequest} body Trunk group POST request object
    * @throws {RequiredError}
    */
    createTrunkGroup(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling createTrunkGroup.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTrunkGroup.');
        }
        const path = `/carriers/{carrierName}/trunk-groups`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a trunk group. Must be at least account admin.
    * @summary Get a trunk group
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @throws {RequiredError}
    */
    getTrunkGroup(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getTrunkGroup.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling getTrunkGroup.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all trunk groups. Must be at least account admin.
    * @summary Get all trunk groups
    * @param {string} carrierName Carrier Name
    * @throws {RequiredError}
    */
    getTrunkGroups(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getTrunkGroups.');
        }
        const path = `/carriers/{carrierName}/trunk-groups`
            .replace(`{${'carrierName'}}`, String(params.carrierName));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a trunk group. Must be at least account admin.
    * @summary Update a trunk group
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @param {TrunkGroupPutRequest} body Trunk group PUT request object
    * @throws {RequiredError}
    */
    updateTrunkGroup(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling updateTrunkGroup.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling updateTrunkGroup.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTrunkGroup.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a trunk. Must be at least account admin.
    * @summary Create a trunk
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @param {TrunkPostRequest} body Trunk POST request object
    * @throws {RequiredError}
    */
    createTrunk(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling createTrunk.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling createTrunk.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTrunk.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}/trunks`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a trunk. Must be at least account admin.
    * @summary Delete a trunk
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @param {string} trunkId Trunk Id
    * @throws {RequiredError}
    */
    deleteTrunk(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling deleteTrunk.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling deleteTrunk.');
        }
        // verify required parameter 'trunkId' is not null or undefined
        if (params.trunkId === null || params.trunkId === undefined) {
            throw new utils_1.RequiredError('trunkId', 'Required parameter trunkId was null or undefined when calling deleteTrunk.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}/trunks/{trunkId}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId))
            .replace(`{${'trunkId'}}`, String(params.trunkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a trunk. Must be at least account admin.
    * @summary Get a trunk
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @param {string} trunkId Trunk Id
    * @throws {RequiredError}
    */
    getTrunk(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getTrunk.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling getTrunk.');
        }
        // verify required parameter 'trunkId' is not null or undefined
        if (params.trunkId === null || params.trunkId === undefined) {
            throw new utils_1.RequiredError('trunkId', 'Required parameter trunkId was null or undefined when calling getTrunk.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}/trunks/{trunkId}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId))
            .replace(`{${'trunkId'}}`, String(params.trunkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all trunks of an account from a carrier. The carrier is based on the account id in the authorization claim. Must be at least account admin.
    * @summary Get all trunks of an account
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @throws {RequiredError}
    */
    getTrunks(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling getTrunks.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling getTrunks.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}/trunks`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Modify a trunk. Must be at least account admin.
    * @summary Modify a trunk
    * @param {string} carrierName Carrier Name
    * @param {string} trunkGroupId Trunk group Id
    * @param {string} trunkId Trunk Id
    * @param {TrunkPutRequest} body Trunk PUT request object
    * @throws {RequiredError}
    */
    updateTrunk(params) {
        // verify required parameter 'carrierName' is not null or undefined
        if (params.carrierName === null || params.carrierName === undefined) {
            throw new utils_1.RequiredError('carrierName', 'Required parameter carrierName was null or undefined when calling updateTrunk.');
        }
        // verify required parameter 'trunkGroupId' is not null or undefined
        if (params.trunkGroupId === null || params.trunkGroupId === undefined) {
            throw new utils_1.RequiredError('trunkGroupId', 'Required parameter trunkGroupId was null or undefined when calling updateTrunk.');
        }
        // verify required parameter 'trunkId' is not null or undefined
        if (params.trunkId === null || params.trunkId === undefined) {
            throw new utils_1.RequiredError('trunkId', 'Required parameter trunkId was null or undefined when calling updateTrunk.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTrunk.');
        }
        const path = `/carriers/{carrierName}/trunk-groups/{trunkGroupId}/trunks/{trunkId}`
            .replace(`{${'carrierName'}}`, String(params.carrierName))
            .replace(`{${'trunkGroupId'}}`, String(params.trunkGroupId))
            .replace(`{${'trunkId'}}`, String(params.trunkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.CarrierService = CarrierService;
